import { render, staticRenderFns } from "./tags_manager.vue?vue&type=template&id=03837b98&scoped=true"
import script from "./tags_manager.vue?vue&type=script&lang=ts"
export * from "./tags_manager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03837b98",
  null
  
)

export default component.exports